import theme from '../../../lib/theme';

const {
  media
} = theme;

export default () => ({
  lOnly: {
    [media.l.down]: {
      display: 'none !important',
    },
  },
});
